/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  EPlotType,
  IStatusPanelItem,
  IUserPermissions,
  IUserSettings,
  IVehicleWithBoxResponse,
  IVehicleWithEsnResponse
} from '../../../core/models';
import { SendPing, StopDeviceHealthCheckPolling } from '../../../core/store/actions';
import {
  getAccountId,
  getHistory,
  getHistoryLoading,
  getPingState,
  getResetState,
  getSelectedStatusItem,
  getUserPermissions,
  getUserSettings,
  getVehicleWithBoxResponse,
  getVehicleWithEsnResponse
} from '../../../core/store/selectors';
import { IAppState } from '../../../core/store/state';
import { EHealthCheckRequestState, IDeviceHealthCheckHistory } from '../../models';

@Component({
  selector: 'fm-device-health-check-container',
  templateUrl: './device-health-check-container.component.html',
  styleUrls: ['./device-health-check-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceHealthCheckContainerComponent implements OnInit, OnDestroy {
  userSettings$: Observable<IUserSettings>;
  statusItem$: Observable<IStatusPanelItem>;
  vehicleWithBox$: Observable<IVehicleWithBoxResponse>;
  vehicleWithEsn$: Observable<IVehicleWithEsnResponse>;
  accountId$: Observable<number>;
  pingState$: Observable<EHealthCheckRequestState>;
  resetState$: Observable<EHealthCheckRequestState>;
  history$: Observable<IDeviceHealthCheckHistory[]>;
  historyLoading$: Observable<boolean>;
  userPermissions$: Observable<IUserPermissions>;

  EPlotType = EPlotType;

  constructor(private readonly _store: Store<IAppState>) {}

  ngOnInit(): void {
    this.userSettings$ = this._store.pipe(select(getUserSettings));
    this.statusItem$ = this._store.pipe(select(getSelectedStatusItem));
    this.vehicleWithBox$ = this._store.pipe(select(getVehicleWithBoxResponse));
    this.vehicleWithEsn$ = this._store.pipe(select(getVehicleWithEsnResponse));
    this.accountId$ = this._store.pipe(select(getAccountId));
    this.pingState$ = this._store.pipe(select(getPingState));
    this.resetState$ = this._store.pipe(select(getResetState));
    this.history$ = this._store.pipe(select(getHistory));
    this.historyLoading$ = this._store.pipe(select(getHistoryLoading));
    this.userPermissions$ = this._store.pipe(select(getUserPermissions));
  }

  ngOnDestroy(): void {
    this._store.dispatch(new StopDeviceHealthCheckPolling());
  }

  initiateHealthCheck(esn: string): void {
    this._store.dispatch(new SendPing(esn));
  }
}
